'use client';
import { createIcon } from '@chakra-ui/icons';


export const HorizonLogo = createIcon({
  displayName: 'horizonLogo',
  viewBox: '0 0 146 20',
  path: (
    <g fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.42.748V19h-4.446v-7.514H5.058V19H.612V.748h4.446v7.15h6.916V.748h4.446Zm11.842 18.434c-1.716 0-3.294-.399-4.732-1.196a9.092 9.092 0 0 1-3.406-3.328c-.832-1.439-1.248-3.05-1.248-4.836 0-1.785.416-3.389 1.248-4.81a9.092 9.092 0 0 1 3.406-3.328C24.968.887 26.546.488 28.262.488c1.716 0 3.284.399 4.706 1.196a8.665 8.665 0 0 1 3.38 3.328c.832 1.421 1.248 3.025 1.248 4.81 0 1.785-.416 3.397-1.248 4.836a8.901 8.901 0 0 1-3.38 3.328c-1.422.797-2.99 1.196-4.706 1.196Zm0-4.056c1.456 0 2.617-.485 3.484-1.456.884-.97 1.326-2.253 1.326-3.848 0-1.612-.442-2.895-1.326-3.848-.867-.97-2.028-1.456-3.484-1.456-1.474 0-2.652.477-3.536 1.43-.867.953-1.3 2.245-1.3 3.874 0 1.612.433 2.903 1.3 3.874.884.953 2.062 1.43 3.536 1.43ZM49.377 19l-3.796-6.89h-1.066V19h-4.446V.748h7.462c1.439 0 2.66.251 3.666.754 1.023.503 1.785 1.196 2.288 2.08.503.867.754 1.837.754 2.912 0 1.213-.347 2.297-1.04 3.25-.676.953-1.681 1.63-3.016 2.028L54.395 19h-5.018ZM44.515 8.964h2.756c.815 0 1.421-.2 1.82-.598.416-.399.624-.962.624-1.69 0-.693-.208-1.24-.624-1.638-.399-.399-1.005-.598-1.82-.598h-2.756v4.524ZM61.476.748V19H57.03V.748h4.446ZM69.43 15.36h7.852V19H64.386v-3.38l7.8-11.232h-7.8V.748h12.896v3.38L69.43 15.36Zm19.388 3.822c-1.716 0-3.293-.399-4.732-1.196a9.093 9.093 0 0 1-3.406-3.328c-.832-1.439-1.248-3.05-1.248-4.836 0-1.785.416-3.389 1.248-4.81a9.093 9.093 0 0 1 3.406-3.328C85.525.887 87.102.488 88.818.488c1.716 0 3.285.399 4.706 1.196a8.664 8.664 0 0 1 3.38 3.328c.832 1.421 1.248 3.025 1.248 4.81 0 1.785-.416 3.397-1.248 4.836a8.9 8.9 0 0 1-3.38 3.328c-1.421.797-2.99 1.196-4.706 1.196Zm0-4.056c1.456 0 2.618-.485 3.484-1.456.884-.97 1.326-2.253 1.326-3.848 0-1.612-.442-2.895-1.326-3.848-.866-.97-2.028-1.456-3.484-1.456-1.473 0-2.652.477-3.536 1.43-.866.953-1.3 2.245-1.3 3.874 0 1.612.434 2.903 1.3 3.874.884.953 2.063 1.43 3.536 1.43ZM116.954 19h-4.446l-7.436-11.258V19h-4.446V.748h4.446l7.436 11.31V.748h4.446V19Zm19.834-4.03h-7.904L127.428 19h-2.496L131.484.982h2.73L140.74 19h-2.496l-1.456-4.03Zm-.676-1.924-3.276-9.152-3.276 9.152h6.552Zm9.85-12.168V19h-2.366V.878h2.366Z"
        fill="currentColor"
      />
    </g>
  ),
});

export const RoundedChart = createIcon({
  displayName: 'RoundedChart',
  viewBox: '0 0 24 24',
  path: (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.846 20c-.515 0-.951-.18-1.31-.539A1.79 1.79 0 0 1 4 18.148v-4.53c0-.515.18-.953.539-1.312.36-.36.796-.54 1.311-.54.515 0 .954.18 1.318.54.364.359.545.797.545 1.312v4.53c0 .516-.182.954-.547 1.313a1.81 1.81 0 0 1-1.32.539ZM12 20c-.515 0-.952-.18-1.311-.539a1.785 1.785 0 0 1-.539-1.31V5.85c0-.515.18-.952.54-1.311A1.78 1.78 0 0 1 12 4c.515 0 .952.18 1.311.539.36.36.539.796.539 1.31V18.15c0 .515-.18.952-.54 1.311A1.78 1.78 0 0 1 12 20Zm6.15 0c-.515 0-.954-.18-1.318-.539a1.78 1.78 0 0 1-.546-1.317V10.71c0-.519.183-.958.548-1.317.365-.36.805-.539 1.32-.539s.951.18 1.31.54c.357.358.536.797.536 1.316v7.434c0 .519-.18.958-.539 1.317-.36.36-.796.539-1.311.539Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const Logo = createIcon({
  displayName: 'Logo',
  viewBox: '0 0 217 39',
  path: (
    <svg width="217" height="39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="38.969"
        height="38.969"
        rx="8.609"
        fill="url(#Essay Builder Logo__a)"
      />
      <g filter="url(#Essay Builder Logo__b)">
        <path
          d="M28.74 14.57a.646.646 0 0 1-.915 0L25 11.738a.646.646 0 0 1-.006-.907l.63-.649a1.882 1.882 0 0 1 1.386-.567c.547 0 1.037.199 1.47.595l.933.907c.434.416.627.898.58 1.446a2.168 2.168 0 0 1-.636 1.388l-.617.619Zm-2.079 1.164a.646.646 0 0 1 .004.916L12.92 30.425a.646.646 0 0 1-.457.19H9.646A.646.646 0 0 1 9 29.97v-2.828c0-.17.068-.335.189-.456l13.72-13.752a.646.646 0 0 1 .911-.004l2.841 2.805Z"
          fill="url(#Essay Builder Logo__c)"
          shape-rendering="crispEdges"
        />
      </g>
      <g filter="url(#Essay Builder Logo__d)">
        <path
          d="M13.613 10.074a.323.323 0 0 0-.583-.001l-1.012 2.109a.324.324 0 0 1-.162.156l-2.174.948a.323.323 0 0 0 .001.593l2.17.937a.32.32 0 0 1 .162.156l1.015 2.112a.323.323 0 0 0 .583-.001l1.004-2.11a.323.323 0 0 1 .164-.157l2.178-.937a.323.323 0 0 0 0-.593l-2.181-.947a.323.323 0 0 1-.164-.158l-1-2.107Zm4.832-1.456a.323.323 0 0 0-.584 0l-.329.695a.323.323 0 0 1-.167.16l-.687.29a.323.323 0 0 0-.004.593l.695.304a.323.323 0 0 1 .162.157l.33.692a.323.323 0 0 0 .583 0l.33-.692a.323.323 0 0 1 .162-.157l.69-.304a.323.323 0 0 0-.005-.593l-.682-.29a.323.323 0 0 1-.165-.16l-.33-.695Z"
          fill="url(#Essay Builder Logo__e)"
          shape-rendering="crispEdges"
        />
      </g>
      <path
        d="M48.455 27.167v-15.91h10.7v2.882h-7.39v3.61h6.963v2.883h-6.962v3.652h7.389v2.883h-10.7Zm16.485.256c-1.282 0-2.4-.299-3.353-.897-.94-.612-1.58-1.43-1.923-2.456l2.35-1.11c.299.626.704 1.117 1.217 1.473a2.928 2.928 0 0 0 1.708.534c.456 0 .805-.093 1.047-.278.242-.185.363-.441.363-.768a.692.692 0 0 0-.128-.428 1.14 1.14 0 0 0-.385-.341c-.17-.1-.384-.185-.64-.257l-1.986-.555c-.954-.27-1.688-.705-2.2-1.303-.513-.612-.769-1.33-.769-2.156 0-.727.185-1.36.555-1.901.37-.541.89-.961 1.56-1.26.669-.314 1.437-.47 2.306-.47 1.139 0 2.135.27 2.99.811a4.268 4.268 0 0 1 1.836 2.243l-2.37 1.11a2.193 2.193 0 0 0-.94-1.153 2.64 2.64 0 0 0-1.516-.448c-.413 0-.74.085-.983.256a.833.833 0 0 0-.341.705.75.75 0 0 0 .128.427 1.1 1.1 0 0 0 .406.341c.199.1.441.193.726.278l1.858.555c.968.285 1.708.72 2.22 1.303.513.57.77 1.274.77 2.114 0 .726-.192 1.36-.577 1.901-.37.541-.89.968-1.559 1.281-.67.3-1.46.449-2.37.449Zm10.563 0c-1.281 0-2.399-.299-3.353-.897-.94-.612-1.58-1.43-1.922-2.456l2.35-1.11c.298.626.704 1.117 1.217 1.473a2.928 2.928 0 0 0 1.708.534c.456 0 .805-.093 1.047-.278.242-.185.363-.441.363-.768a.691.691 0 0 0-.128-.428 1.14 1.14 0 0 0-.385-.341c-.17-.1-.384-.185-.64-.257l-1.987-.555c-.953-.27-1.687-.705-2.2-1.303-.512-.612-.768-1.33-.768-2.156 0-.727.185-1.36.555-1.901.37-.541.89-.961 1.56-1.26.668-.314 1.437-.47 2.306-.47 1.139 0 2.135.27 2.99.811a4.268 4.268 0 0 1 1.836 2.243l-2.37 1.11a2.193 2.193 0 0 0-.94-1.153 2.64 2.64 0 0 0-1.516-.448c-.413 0-.74.085-.983.256a.833.833 0 0 0-.341.705.75.75 0 0 0 .128.427 1.1 1.1 0 0 0 .406.341c.199.1.44.193.726.278l1.858.555c.968.285 1.708.72 2.22 1.303.513.57.77 1.274.77 2.114 0 .726-.193 1.36-.577 1.901-.37.541-.89.968-1.56 1.281-.668.3-1.458.449-2.37.449Zm9.603 0c-.84 0-1.566-.135-2.178-.406-.612-.27-1.082-.655-1.41-1.153-.327-.513-.49-1.118-.49-1.815 0-.655.149-1.232.448-1.73.299-.513.754-.94 1.366-1.282.627-.341 1.403-.583 2.328-.726l3.567-.576v2.349l-2.99.534c-.456.085-.805.235-1.047.448-.242.2-.363.492-.363.876 0 .356.136.634.406.833.27.2.605.299 1.004.299.527 0 .99-.114 1.388-.342a2.37 2.37 0 0 0 .918-.918 2.58 2.58 0 0 0 .342-1.303v-3.033c0-.44-.178-.811-.534-1.11-.342-.3-.811-.449-1.41-.449-.569 0-1.074.157-1.516.47-.427.314-.74.726-.94 1.239l-2.562-1.217a4.163 4.163 0 0 1 1.09-1.688 5.184 5.184 0 0 1 1.793-1.089 6.578 6.578 0 0 1 2.285-.384c.983 0 1.851.178 2.606.534.754.356 1.338.854 1.75 1.495.428.626.642 1.36.642 2.2v7.688h-2.99v-1.88l.726-.128a5.91 5.91 0 0 1-1.132 1.282 4.18 4.18 0 0 1-1.388.726 5.382 5.382 0 0 1-1.709.256Zm10.23 4.485c-.342 0-.676-.029-1.004-.086a2.867 2.867 0 0 1-.833-.277v-2.627a6.017 6.017 0 0 0 1.453.213c.626 0 1.075-.149 1.345-.448.27-.299.491-.64.662-1.025l.79-1.815-.042 2.67-5.126-13.007h3.438l3.396 9.247h-1.281l3.395-9.247h3.439l-4.998 12.75c-.313.811-.697 1.488-1.153 2.029a4.517 4.517 0 0 1-1.559 1.217c-.57.27-1.21.406-1.922.406Zm11.395-9.183v-2.777h9.61v2.777h-9.61Zm12.553 4.442v-15.91h6.727c1.096 0 2.036.184 2.819.555.783.37 1.381.904 1.794 1.601.413.684.619 1.517.619 2.499a3.85 3.85 0 0 1-.576 2.007c-.385.627-1.018 1.154-1.901 1.58v-1.622c.84.327 1.488.719 1.943 1.174.456.456.769.954.94 1.495.171.527.256 1.082.256 1.666 0 1.566-.519 2.784-1.559 3.652-1.039.868-2.484 1.303-4.335 1.303h-6.727Zm3.31-2.883h3.801c.67 0 1.204-.193 1.602-.577.399-.384.598-.883.598-1.495 0-.626-.199-1.132-.598-1.516-.398-.385-.932-.577-1.602-.577h-3.801v4.165Zm0-7.048h3.652c.513 0 .918-.142 1.217-.427.313-.3.47-.69.47-1.175 0-.484-.157-.868-.47-1.153-.299-.299-.704-.448-1.217-.448h-3.652v3.203Zm14.959 10.187c-.94 0-1.745-.2-2.414-.598a3.971 3.971 0 0 1-1.495-1.709c-.341-.726-.512-1.573-.512-2.54v-7.07h3.203v6.813c0 .441.086.833.257 1.174a2 2 0 0 0 .768.77 2.22 2.22 0 0 0 1.111.277c.427 0 .797-.093 1.11-.278a1.85 1.85 0 0 0 .748-.769c.185-.341.278-.733.278-1.174v-6.813h3.203v11.66h-2.99V24.86l.171.513c-.271.697-.712 1.217-1.324 1.559-.598.327-1.303.491-2.114.491Zm8.171-.256v-11.66h3.204v11.66h-3.204Zm0-12.707v-3.204h3.204v3.204h-3.204Zm5.121 12.707V11h3.203v16.167h-3.203Zm10.609.256c-1.139 0-2.157-.27-3.054-.812a5.976 5.976 0 0 1-2.136-2.2c-.512-.925-.769-1.95-.769-3.075 0-1.139.264-2.164.791-3.075a5.967 5.967 0 0 1 2.135-2.2c.897-.54 1.901-.811 3.011-.811.855 0 1.609.164 2.264.491a3.746 3.746 0 0 1 1.58 1.346l-.491.64V11h3.204v16.167h-2.99V25.03l.299.662c-.399.57-.94 1.004-1.623 1.303a5.719 5.719 0 0 1-2.221.427Zm.384-2.883c.584 0 1.096-.135 1.538-.406.441-.27.783-.648 1.025-1.132.256-.484.384-1.04.384-1.666 0-.626-.128-1.181-.384-1.665a2.727 2.727 0 0 0-1.025-1.132c-.442-.27-.954-.406-1.538-.406-.584 0-1.11.142-1.58.427-.456.27-.812.648-1.068 1.132-.256.47-.384 1.018-.384 1.644 0 .627.128 1.182.384 1.666s.612.862 1.068 1.132c.47.27.996.406 1.58.406Zm13.686 2.883c-1.238 0-2.313-.27-3.224-.812a5.76 5.76 0 0 1-2.115-2.22c-.498-.926-.747-1.951-.747-3.076 0-1.167.256-2.207.769-3.118a5.9 5.9 0 0 1 2.114-2.157c.883-.527 1.879-.79 2.99-.79.925 0 1.744.15 2.456.448.712.285 1.31.69 1.794 1.218a5.318 5.318 0 0 1 1.132 1.836 6.345 6.345 0 0 1 .341 2.926c-.014.214-.05.399-.107.555h-8.734v-2.349h6.919l-1.516 1.11c.142-.611.135-1.152-.021-1.622a2.113 2.113 0 0 0-.833-1.132c-.385-.285-.862-.427-1.431-.427-.555 0-1.032.135-1.431.405s-.698.67-.897 1.196c-.199.527-.278 1.168-.235 1.922-.057.655.021 1.232.235 1.73.213.499.541.89.982 1.175.442.27.976.406 1.602.406.57 0 1.054-.114 1.452-.342.413-.228.733-.541.961-.94l2.563 1.218a3.83 3.83 0 0 1-1.089 1.495 5.318 5.318 0 0 1-1.73 1.003 6.786 6.786 0 0 1-2.2.342Zm7.012-.256v-11.66h2.99v2.797l-.214-.406c.257-.982.677-1.644 1.26-1.986.598-.356 1.303-.534 2.115-.534h.683v2.776h-1.004c-.783 0-1.416.242-1.9.727-.484.47-.726 1.139-.726 2.007v6.279h-3.204Zm8.536 0v-3.204h3.204v3.204h-3.204Zm5.771 0 5.382-15.91h4.399l5.382 15.91h-3.609l-1.068-3.247h-5.83l-1.068 3.247h-3.588Zm5.574-6.13h3.993l-2.434-7.517h.897l-2.456 7.517Zm10.815 6.13v-15.91h3.31v15.91h-3.31Z"
        fill="#120F43"
      />
      <defs>
        <linearGradient
          id="Essay Builder Logo__a"
          x1="23.267"
          y1="32.321"
          x2="31.554"
          y2="2.363"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4A25E1" />
          <stop offset="1" stop-color="#9C84FF" />
        </linearGradient>
        <linearGradient
          id="Essay Builder Logo__c"
          x1="23.171"
          y1="19.5"
          x2="20.095"
          y2="34.225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" stop-opacity=".96" />
          <stop offset="1" stop-color="#fff" stop-opacity=".23" />
        </linearGradient>
        <linearGradient
          id="Essay Builder Logo__e"
          x1="16.631"
          y1="13.13"
          x2="15.4"
          y2="6.258"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" stop-opacity=".96" />
          <stop offset="1" stop-color="#fff" stop-opacity=".23" />
        </linearGradient>
        <filter
          id="Essay Builder Logo__b"
          x="4.071"
          y="5.309"
          width="30.292"
          height="31.142"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.02" dy="1.926" />
          <feGaussianBlur stdDeviation="1.955" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.0506089 0 0 0 0 0.0159861 0 0 0 0 0.191833 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_6125"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx=".963" dy="-.907" />
          <feGaussianBlur stdDeviation="1.7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0" />
          <feBlend
            in2="effect1_dropShadow_1_6125"
            result="effect2_dropShadow_1_6125"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1_6125"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.38" />
          <feGaussianBlur stdDeviation="1.501" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend in2="shape" result="effect3_innerShadow_1_6125" />
        </filter>
        <filter
          id="Essay Builder Logo__d"
          x="4.559"
          y="4.127"
          width="19.622"
          height="18.976"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1.02" dy="1.926" />
          <feGaussianBlur stdDeviation="1.955" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.0506089 0 0 0 0 0.0159861 0 0 0 0 0.191833 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_6125"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx=".963" dy="-.907" />
          <feGaussianBlur stdDeviation="1.7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0" />
          <feBlend
            in2="effect1_dropShadow_1_6125"
            result="effect2_dropShadow_1_6125"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1_6125"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.38" />
          <feGaussianBlur stdDeviation="1.501" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend in2="shape" result="effect3_innerShadow_1_6125" />
        </filter>
      </defs>
    </svg>
  ),
});
